import { configureRequest } from "@asosteam/asos-web-request";
import { name, version } from "../../../appDetails";
import clientConfigurationProvider from "../../providers/clientConfigurationProvider";
import getRetryCondition from "./getRetryCondition";
import getRetryDelay from "./getRetryDelay";

export default ({ retryCallback }) => {
  const { recommendationsRequestTimeout: timeout } =
    clientConfigurationProvider();

  return configureRequest({
    defaultTimeout: timeout,
    retries: 2,
    retryDelay: getRetryDelay(),
    retryCondition: getRetryCondition({ retryCallback }),
    shouldResetTimeout: true,
    client: {
      name,
      version
    }
  });
};
